module.exports = __webpack_public_path__ + "img/2.3851b8b2.png";